import { combineReducers } from "redux";

import category from "../features/admin/categorys/category/Slice";

import product from "../features/admin/categorys/product/Slice";

import platform from "../features/admin/categorys/platform/Slice";

import project from "../features/admin/categorys/project/Slice";

import common from "../features/admin/common/Slice";

const categorys = combineReducers({
    category,
    product,
    platform,
    project,
    common
});

export default categorys;